import { IVwProdutosMaisConsumidosResponsavel } from '@/types/views/IVwProdutosMaisConsumidosResponsavel';
import { PostgrestSingleResponse } from '@supabase/supabase-js';
import { supabase } from '../../../../supabaseConfig';

export class VwProdutosMaisConsumidosResponsavelService {
  /**
   * Retorna o ranking de produtos mais consumidos por responsável, mês e organização
   */
  async getByResponsavelMes(
    responsavelId: number,
    organizacaoId: number,
    mes: string // formato 'YYYY-MM'
  ): Promise<PostgrestSingleResponse<IVwProdutosMaisConsumidosResponsavel[]>> {
    return supabase
      .from('vw_produtos_mais_consumidos_responsavel')
      .select('*')
      .eq('responsavel_id', responsavelId)
      .eq('organizacao_id', organizacaoId)
      .eq('mes', mes)
      .order('total_consumido', { ascending: false })
      .order('frequencia', { ascending: false });
  }
}
